import { SessionHelper } from "app/helpers/sessionHelper";
import { ExchangeMarketRowType } from "app/types/reportType";
import React from "react";
import { injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import "../StatementExchange.scss";
import StatementExchangeFooter from "../StatementExchangeFooter/StatementExchangeFooter";
import StatementExchangeGrid from "./components/StatementExchangeGrid/StatementExchangeGrid";

type PropsTypes = {
  statementList: ExchangeMarketRowType[];
  totalPayout: number;
  intl: IntlShape;
  loadStatementExchangeBetsPerMarket: Function;
};

const StatementExchangeMarket: React.FC<PropsTypes> = ({
  statementList,
  totalPayout,
  loadStatementExchangeBetsPerMarket,
}) => {
  const uiViewMode = SessionHelper.isAsianRouteAndSessionView()
    ? "asian"
    : "euro";
  return (
    <div className={`statement-exchange--${uiViewMode}`}>
      <StatementExchangeGrid
        statementList={statementList}
        loadStatementExchangeBetsPerMarket={loadStatementExchangeBetsPerMarket}
      />
      <StatementExchangeFooter totalPayout={totalPayout} />
    </div>
  );
};

const mapStateToProps = (state: {
  statementListModel: {
    totalPayout: number;
    statementList: ExchangeMarketRowType[];
  };
  userModel: {
    exchangeCommissionRate: number;
  };
}) => ({
  totalPayout: state.statementListModel.totalPayout,
  statementList: state.statementListModel.statementList,
  user: state.userModel.exchangeCommissionRate,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadStatementExchangeBetsPerMarket: (marketId: number) => {
    dispatch.statementListModel.loadStatementExchangeBetsPerMarket({
      marketId,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(StatementExchangeMarket)) as any;
